// Module
var code = "<p>The benefits offered to servicemembers are different depending on the types of loans you have. Review the specifics for each by selecting your loan type below:</p> ";
// Exports
export default code;